/** Logo u `public/logo.png` */
export const LOGO_SRC = `${process.env.PUBLIC_URL}/logo.png`;
